import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { Form, Utils } from 'app/main/components';
import { useSettings, useUserData } from 'app/main/components/hooks';
import { ModuleSearchField, SimpleTextField } from 'app/main/components/fields';

interface CompaniesMergeDialogProps {
	compUid: string;
	updateRefresh: VoidFunction;
}

export const showCompaniesMergeDialog = (props: CompaniesMergeDialogProps) =>
	openDialog({ children: <CompaniesMergeDialog {...props} />, maxWidth: 'sm', fullWidth: true });

export default function CompaniesMergeDialog({ compUid, updateRefresh }: CompaniesMergeDialogProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();
	const userData = useUserData();

	const [replacedCompUid, setReplacedCompUid] = React.useState<string | null>(null);
	const [reason, setReason] = React.useState<string | null>(null);

	function submitSave() {
		dispatch(Utils.alertProgressMsg(t));

		Utils.executeStored({
			action: 'st_companies_merge',
			dispatch,
			data: {
				comp_uid: replacedCompUid,
				comp_replace_uid: compUid,
				user_modified_uid: userData.user_uid,
				reason
			},
			successHandler: response => {
				dispatch(Utils.alertSuccessMsg(t));
				dispatch(closeDialog());
				updateRefresh();
			}
		});
	}

	return (
		<>
			<DialogTitle>{t('COMPANIES_MERGE_DIALOG_TITLE')}</DialogTitle>
			<DialogContent>
				<Form id="companiesMergeDialog" onSubmit={submitSave}>
					<Grid container spacing={2}>
						<Grid size={12}>
							<Typography>{t('COMPANIES_MERGE_DIALOG_DESCRIPTION')}</Typography>
						</Grid>
						<Grid size={12}>
							<ModuleSearchField
								name="comp_replace_uid"
								label={t('COMPANIES_MERGE_DIALOG_FIELD_COMPANY')}
								module="companies"
								uid={replacedCompUid}
								filters={[
									{
										filt_field: 'comp_uid',
										filt_clause: 'not_equal',
										filt_value: compUid
									}
								]}
								isEdit
								sendChange={(_name, newValue) => setReplacedCompUid(newValue)}
								required
								validationError={t('ERROR_TEXT_REQUIRED')}
							/>
						</Grid>
						<Grid size={12}>
							<SimpleTextField
								name="reason"
								label={t('COMPANIES_MERGE_DIALOG_FIELD_REASON')}
								value={reason}
								sendChange={(_name, newValue) => setReason(newValue)}
								isEdit
								required
								validationError={t('ERROR_TEXT_REQUIRED')}
							/>
						</Grid>
					</Grid>
				</Form>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => dispatch(closeDialog())}>{t('DIALOG_ACTION_CANCEL')}</Button>
				<Button type="submit" form="companiesMergeDialog" color="secondary">
					{t('DIALOG_ACTION_CONFIRM')}
				</Button>
			</DialogActions>
		</>
	);
}
